import { Component, inject, Input, ViewEncapsulation } from '@angular/core';
import { AppNotificationInterface } from '../../../models/app-notification.interface';
import { AppNotificationsService } from '../../../services/app-notifications.service';

@Component({
  selector: 'app-notification',
  standalone: false,
  templateUrl: './app-notification.component.html',
  styleUrls: ['./app-notification.component.scss'],
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'angular-component-wrapper',
  },
})
export class AppNotificationComponent {
  private readonly _appNotificationsService = inject(AppNotificationsService);

  @Input() notification!: AppNotificationInterface;

  get notificationTypeClass() {
    return this.notification
      ? `simx-app-notification-type--${this.notification!.type.toLowerCase()}`
      : '';
  }

  handleNotificationClick(): void {
    this._appNotificationsService.dismissNotification(this.notification!.id);
  }
}
